<script>
export default {
   name: 'NoCloud',
};
</script>

<template>
   <svg xmlns="http://www.w3.org/2000/svg" width="85" height="86" fill="none" viewBox="0 0 85 86">
      <path
         fill="#edecf1"
         d="m52.179 30.19 3.857 10.286 6 1.714 2.571 8.143-4.285 5.571H25.179l-5.572-5.571 1.286-8.143 6.857-4.714 4.286-7.286 10.714-3.857z"
      />
      <path
         fill="#178ece"
         d="M31.218 29.026A16.6 16.6 0 0 1 42 25c8.07 0 14.769 6 15.498 13.737 4.776.675 8.502 4.674 8.502 9.582C66 53.707 61.506 58 56.061 58H29.343C23.124 58 18 53.098 18 46.954c0-5.289 3.798-9.669 8.826-10.779.429-2.589 2.094-5.169 4.392-7.149m1.959 2.271c-2.271 1.959-3.459 4.32-3.459 6.168v1.344l-1.335.147c-4.191.459-7.383 3.9-7.383 7.998C21 51.355 24.69 55 29.343 55h26.718C59.94 55 63 51.964 63 48.319c0-3.648-3.06-6.684-6.939-6.684h-1.5v-1.5C54.564 33.475 48.984 28 42 28c-3.24.013-6.37 1.18-8.823 3.297"
      />
      <path
         fill="#bbc7d5"
         d="M42.125.945C65.255.945 84.18 19.87 84.18 43S65.256 85.055 42.125 85.055C18.995 85.055.07 66.13.07 43S18.995.945 42.125.945m0 8.41c-7.99 0-15.14 2.524-20.607 7.15L68.62 63.607C72.826 57.719 75.77 50.57 75.77 43c0-18.504-15.14-33.644-33.645-33.644m20.607 60.14L15.631 22.393C11.005 27.86 8.48 35.009 8.48 43c0 18.504 15.14 33.644 33.644 33.644 7.99 0 15.14-2.523 20.607-7.15"
      />
   </svg>
</template>

<style scoped lang="scss"></style>
